import RandomCanvas from './RandomCanvas';
import RandomSmoothCanvas from './RandomSmoothCanvas';
import React from 'react';

class IdleCanvas extends React.Component {

    constructor(props) {
        super(props);

        var strategies = ['origin', 'randcol', 'rainbow', 'rainbow_origin']
        var colors = ['#000000', '#AA0000', '#00AA00', '#0000AA']

        var strategy = strategies[Math.floor(Math.random() * strategies.length)]
        var color = colors[Math.floor(Math.random() * colors.length)]

        this.state = {
            canvas: <RandomSmoothCanvas updateInterval={50} drawingStrategy={strategy} color={color} width={props.width}/>
        }
    }

    render() {
        return (
            <div>{this.state.canvas}</div>
        );
    }
}

export default IdleCanvas;
